import { IconArchive } from './icons/archive'
import { Alexa } from './icons/alexa'
import { IconArrow } from './icons/arrow'
import { IconBulb } from './icons/bulb'
import { IconClaim } from './icons/bxUserCheck'
import { IconCamera } from './icons/camera'
import { IconCameraOff } from './icons/cameraOff'
import { IconChat } from './icons/chat'
import { IconCheckboxSquare } from './icons/checkboxSquare'
import { IconCheckCircle } from './icons/checkCircle'
import { IconChevronLeft } from './icons/chevronLeft'
import { IconChevronRight } from './icons/chevronRight'
import { IconCircleLoader } from './icons/circleLoader'
import { IconCloudUpload } from './icons/cloudUpload'
import { IconContract } from './icons/contact'
import { IconDepartment } from './icons/department'
import { IconDownload } from './icons/download'
import { IconError } from './icons/error'
import { IconExport } from './icons/export'
import { IconGrid } from './icons/grid'
import { IconHoliday } from './icons/holiday'
import { IconList } from './icons/list'
import { IconLoader } from './icons/loader'
import { IconMenu } from './icons/menu'
import { IconMessageDetails } from './icons/messageDetail'
import { IconPen } from './icons/pen'
import { IconPersonAttention } from './icons/person-attention'
import { IconPersonDeleted } from './icons/person-deleted'
import { IconPersonNew } from './icons/person-new'
import { IconPill } from './icons/pill'
import { IconPlus } from './icons/plus'
import { IconProfile } from './icons/profile'
import { IconQuestion } from './icons/question'
import { QuestionMark } from './icons/question-mark'
import { IconReport } from './icons/report'
import { IconSchool } from './icons/school'
import { IconSearch } from './icons/search'
import { IconSelectMultiple } from './icons/selectMultiple'
import { IconSettings } from './icons/settings'
import { IconSinkingShip } from './icons/sinkingShip'
import { IconSlack } from './icons/slack'
import { IconSuccess } from './icons/success'
import { IconSupport } from './icons/support'
import { IconTrash } from './icons/trash'
import { IconUser } from './icons/user'
import { IconUnclaim } from './icons/user-x'
import { IconVaccation } from './icons/vacation'
import { IconWork } from './icons/work'
import { IconX } from './icons/x'
import { IconOptions } from './icons/options'

export const Icons = {
  Arrow: IconArrow,
  Archive: IconArchive,
  Bulb: IconBulb,
  BurgerMenu: IconMenu,
  Camera: IconCamera,
  CameraOff: IconCameraOff,
  Chat: IconChat,
  Checkbox: IconCheckboxSquare,
  CheckCircle: IconCheckCircle,
  ChevronLeft: IconChevronLeft,
  ChevronRight: IconChevronRight,
  CircleLoader: IconCircleLoader,
  Claim: IconClaim,
  CloudUpload: IconCloudUpload,
  Comment: IconMessageDetails,
  Contact: IconContract,
  Department: IconDepartment,
  Download: IconDownload,
  Error: IconError,
  Export: IconExport,
  GridMenu: IconGrid,
  Holiday: IconHoliday,
  ListMenu: IconList,
  Loader: IconLoader,
  Pen: IconPen,
  Pill: IconPill,
  Profile: IconProfile,
  Question: IconQuestion,
  School: IconSchool,
  SelectAll: IconSelectMultiple,
  Settings: IconSettings,
  SinkingShip: IconSinkingShip,
  Slack: IconSlack,
  Success: IconSuccess,
  Support: IconSupport,
  Trash: IconTrash,
  Unclaim: IconUnclaim,
  User: IconUser,
  Vacation: IconVaccation,
  Work: IconWork,
  X: IconX,
  Plus: IconPlus,
  Search: IconSearch,
  PersonAttention: IconPersonAttention,
  PersonDeleted: IconPersonDeleted,
  PersonNew: IconPersonNew,
  Report: IconReport,
  Alexa: Alexa,
  QuestionMark: QuestionMark,
  Options: IconOptions,
}
